import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_85: FaireProductEntity = {
  token: "legacy_prod_abbott-85",
  type: "product",
  name: "Large Velvet Pouch with 3D Heart, Dark Grey 5×7 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/cf2aa4c877e759ade64b27aa3890810154c59435f176ec0500f5845256a39d4c.jpeg",
  priceDollars: 14,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
